import React from "react";
import { Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function LoginNavItem({ onClickClose }) {
  const { instance, accounts } = useMsal();
  const user = accounts[0];
  const navigate = useNavigate();

  const location = useLocation();
  const isActive = location.pathname === "/konto";

  const handleClick = () => {
    if (user) {
      navigate("/konto");
      onClickClose && onClickClose();
    } else {
      instance.loginRedirect();
    }
  };

  return (
    <Typography
      onClick={handleClick}
      sx={{
        textDecoration: "none",
        color: "#587d18",
        mx: 1,
        position: "relative",
        fontWeight: 500,
        cursor: "pointer",
        "&:hover::after": {
          content: '""',
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          height: "2px",
          backgroundColor: "#587d18",
        },
        "&::after": {
          content: isActive ? '""' : "none",
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          height: "2px",
          backgroundColor: "#587d18",
        },
      }}
    >
      {user ? "Moje konto" : "Zaloguj się"}
    </Typography>
  );
}
